export default __webpack_public_path__ + "0311a5413d0568077fe2a093508a7595.png";